import { render } from "./Q2Detaille.vue?vue&type=template&id=288e31c4"
import script from "./Q2Detaille.vue?vue&type=script&lang=js"
export * from "./Q2Detaille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__